import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo/ht.png";

const Logo = () => {
  return (
    <div className="logo">
      <Link to={process.env.PUBLIC_URL + "/"}>
        <img src={logo} alt="HT-Call" className="img-fluid" />
      </Link>
    </div>
  );
};

export default Logo;
